module.exports = __webpack_public_path__ + "static/media/chubb.0e7e344e.webp";